import { Box, Button, Modal, Typography } from "@mui/material";
import React from "react";

function WelcomeModal1({openModal1, handleCloseModal1, style}) {
    return (<Modal open={openModal1} onClose={handleCloseModal1} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
    <Box sx={style}>
      <Typography id="modal-modal-title" variant="h6" component="h2">
        Welcome to VocaBuddy! 🎉
      </Typography>
      <Typography id="modal-modal-description" sx={{
    mt: 2
  }}>
        VocaBuddy is here to help you to store and practice your vocabulary.
        We’ve just started our journey..
      </Typography>
      <Button variant="contained" onClick={handleCloseModal1} sx={{
    my: 1
  }}>
        Next
      </Button>
    </Box>
  </Modal>);
  }

export default WelcomeModal1;